export enum BrainTreeScripts  {
    client  = 'https://js.braintreegateway.com/web/3.120.2/js/client.min.js',
    paypal  = 'https://js.braintreegateway.com/web/3.120.2/js/paypal-checkout.min.js',
    hostedFields  = 'https://js.braintreegateway.com/web/3.120.2/js/hosted-fields.min.js',
    googlePay  = 'https://js.braintreegateway.com/web/3.120.2/js/google-payment.min.js',
    localPay  = 'https://js.braintreegateway.com/web/3.120.2/js/local-payment.min.js',
    applePay  = 'https://js.braintreegateway.com/web/3.120.2/js/apple-pay.min.js',
    dataCollector  = 'https://js.braintreegateway.com/web/3.120.2/js/data-collector.min.js',
    threeDSecure  = 'https://js.braintreegateway.com/web/3.120.2/js/three-d-secure.min.js'
}